import React, { ReactElement } from 'react'
import BarryIcon from 'components/Barry/BarryComponents/BarryIcon'
import useStaticBarry from 'components/Barry/hooks/useBarryStaticPage'

export default function StaticBarryIcon({
  handleToggle,
  barryPopupMessage,
}: {
  handleToggle: () => void
  barryPopupMessage: React.ReactNode
}): ReactElement {
  const { handleHelloMessagePopupInteraction, hasHelloMessagePopup } = useStaticBarry()

  return (
    <BarryIcon
      hasPopupMessage={hasHelloMessagePopup}
      barryPopupMessage={barryPopupMessage}
      handleToggle={handleToggle}
      onPopupInteraction={handleHelloMessagePopupInteraction}
    />
  )
}
